<template>
  <div class="page">
    <div class="workspace">
      <div class="ws-unit">
        <div class="ws-unit-header ">
          <div>
            <el-button type="primary" size="small" round icon="el-icon-plus" @click="create">添加</el-button>
          </div>
          <div class="ws-unit-toolbar">
          </div>
        </div>
        <div class="ws-unit-body">
          <domain-table ref="table"/>
        </div>
      </div>
    </div>
    <domain-form @success="onSaveSuccess" ref="dialog" />
  </div>
</template>

<script>
import DomainTable from "./Table";
import DomainForm from "./Form";

export default {
    name: "Product",
    components: {
        DomainTable,
        DomainForm
    },
    methods:{
        create(){
            this.$refs.dialog.show();
        },
        onSaveSuccess(){
            this.$refs.table.loadData();
        }
    }

}
</script>

<style scoped>

</style>